export { default } from './ServiceWorkerRegister'
